import React from 'react';
import { ProcessosAtividadesDTO } from '../../../../viewmodel/CronogramaViewModel';

interface LegendaProcessosProps {
    atividadesOutrasDTO: ProcessosAtividadesDTO[];
    corUsuario: string
}

const LegendaProcessos: React.FC<LegendaProcessosProps> = ({ atividadesOutrasDTO, corUsuario }) => {
    return (
        <div className="legendas-container">
            <div className="legenda-item">
                <span className="cor-processo" style={{ backgroundColor: corUsuario }}></span>
                <span className="nome-processo">{'Processo atual'}</span>
            </div>
            {atividadesOutrasDTO.map((processo, index) => (
                <div key={index} className="legenda-item">
                    <span className="cor-processo" style={{ backgroundColor: processo.cor }}></span>
                    <span className="nome-processo">{processo.processoNome}</span>
                </div>
            ))}
        </div>
    );
};

export default LegendaProcessos;
